import script from "./onceItem1.vue?vue&type=script&setup=true&lang=js"
export * from "./onceItem1.vue?vue&type=script&setup=true&lang=js"

import "./onceItem1.vue?vue&type=style&index=0&id=ad3b6d06&lang=less"

const __exports__ = script;

export default __exports__